import React, { useState } from "react";
import { toast } from "react-toastify";

interface Props {
  orderData: any;
  onClose: () => void;
}

const StockDetails: React.FC<Props> = ({ orderData, onClose }) => {
  const [loading, setLoading] = useState(false);

  if (!orderData) {
    return (
      <div className="bg-white p-5 rounded-lg shadow-lg text-center">
        <p>No stock data available.</p>
        <button
          onClick={onClose}
          className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md"
        >
          Close
        </button>
      </div>
    );
  }

  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    return isNaN(d.getTime()) ? "Invalid Date" : d.toLocaleDateString();
  };

  const handleDownloadCSV = () => {
    setLoading(true);

    const csv =
      "Item Name,Quantity,Remark\n" +
      (orderData.items || [])
        .map(
          (i: any) =>
            `${i.name || i.itemName || "N/A"},${i.quantity || 0},${i.remark || "-"}`
        )
        .join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${orderData.orderNumber || "stock"}.csv`;
    a.click();
    URL.revokeObjectURL(url);

    setTimeout(() => {
      setLoading(false);
      toast.success("Stock Details Downloaded Successfully");
    }, 800);
  };

  return (
    <div className="lg:w-4xl xl:w-4xl w-full max-h-[700px] overflow-y-auto no-scrollbar rounded-xl bg-white dark:bg-zinc-800 dark:text-white py-5 px-10 flex flex-col relative">

      {/* Close Button */}
      <button
        className="absolute top-2 right-2 text-gray-500 hover:text-gray-800 text-2xl font-bold z-10"
        onClick={onClose}
      >
        &times;
      </button>

      {/* ================= HEADER ================= */}
      <div className="flex flex-col xl:flex-row justify-between items-start mb-6">

       <div className="flex flex-col items-center">
    {/* Logo */}
    <img
      src="/images/user-pic.png"
      alt="Logo"
      className="w-16 h-16 rounded-full bg-gray-100"
    />

    {/* Generated By (NICHE) */}
    <div className="mt-2 text-sm text-center">
      <span className="font-mono font-semibold text-lg block">
        Generated By
      </span>
      <span>
        Employee Name:{" "}
        <span className="font-semibold">
          {orderData.generatedBy?.username || "N/A"}
        </span>
      </span>
    </div>
  </div>

        {/* Right : Order Info */}
        <div className="text-end mt-4 xl:mt-0">
          <span className="text-xs font-semibold">Order Number</span>
          <div className="text-blue-600 underline text-lg font-mono font-semibold">
            #{orderData.orderNumber || "N/A"}
          </div>

          <div className="text-xs font-semibold mt-2">
            Created Date:
            <span className="font-bold ml-1">
              {formatDate(orderData.createdAt)}
            </span>
          </div>

          <div className="text-xs font-semibold">
            Instrument:
            <span className="font-bold ml-1">
              {orderData.instrument?.name || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* ================= RESPONSIBLE PERSON ================= */}
      {/* Responsible Person */}
<div className="flex justify-end mb-6">
  <div className="bg-gray-100 dark:bg-zinc-900 px-4 py-3 rounded-lg text-sm w-fit">

    <div className="font-mono font-semibold text-base">
      Responsible Person -{" "}
      <span className="font-bold">
        {orderData.responsiblePerson || "N/A"}
      </span>
    </div>

    <div className="font-mono font-semibold text-base mt-1">
      Approved By -{" "}
      <span className="font-bold text-green-600">
        {orderData.approvedBy || "Pending"}
      </span>
    </div>

  </div>
</div>


      {/* ================= INSTRUMENT DETAILS ================= */}
      <div className="bg-gray-100 dark:bg-zinc-900 px-4 py-4 text-sm rounded-lg mb-4">
        <span className="font-mono font-semibold text-lg">
          Instrument Details
        </span>
        <div className="mt-2 space-y-1">
          <div>
            Instrument Name:{" "}
            <span className="font-semibold">
              {orderData.instrument?.name || "-"}
            </span>
          </div>
          <div>
            Quantity Requested:{" "}
            <span className="font-semibold">
              {orderData.quantity || 1}
            </span>
          </div>
          <div>
             remark:{" "}
            <span className="font-semibold">
              {orderData.remark || "-"}
            </span>
          </div>
        </div>
      </div>

      {/* ================= REMARK ================= */}
      {orderData.parameters && (
        <div className="bg-gray-100 dark:bg-zinc-900 px-4 py-4 text-sm rounded-lg mb-4">
          <span className="font-mono font-semibold text-lg">parameters</span>
          <p className="mt-2 whitespace-pre-line">
            {orderData.parameters}
          </p>
        </div>
      )}

      {/* ================= ACTIONS ================= */}
      <div className="flex justify-between mt-6">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-300 rounded-lg text-sm font-semibold"
        >
          Close
        </button>

        <button
          onClick={handleDownloadCSV}
          disabled={loading}
          className="px-4 py-2 bg-blue-500 rounded-lg text-white text-sm font-semibold disabled:opacity-60"
        >
          {loading ? "Downloading..." : "Download"}
        </button>
      </div>
    </div>
  );
};

export default StockDetails;
